import { useState } from "react";

export default function Newsletter() {
  const [value, setValue] = useState("");
  const [done, setDone] = useState(false);

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (!value.trim()) return;
    setDone(true);
    setValue("");
    window.setTimeout(() => setDone(false), 3200);
  }

  return (
    <section id="newsletter" className="w-full bg-background-50 py-10 md:py-14">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-3xl bg-foreground-950 px-5 py-8 md:px-10 md:py-12">
          <div className="pointer-events-none absolute -right-10 -top-10 h-52 w-52 rounded-full bg-primary-600/50 blur-3xl"></div>
          <div className="pointer-events-none absolute -bottom-12 left-1/3 h-44 w-44 rounded-full bg-accent-500/30 blur-3xl"></div>

          <div className="relative mx-auto flex max-w-2xl flex-col items-center text-center">
            <span className="mb-3 inline-flex items-center gap-1.5 rounded-full bg-background-50/10 px-3 py-1 text-xs font-bold text-accent-300 ring-1 ring-background-50/15">
              <i className="ri-notification-3-line"></i>
              塌房第一声，先告诉订阅的人
            </span>
            <h3 className="font-display text-2xl font-black leading-snug text-background-50 md:text-4xl">
              订阅「呱呱黑料」快讯
              <span className="block text-accent-300">别错过每一个脱粉瞬间</span>
            </h3>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-background-100/75">
              把每周新进档案的实锤现场、口碑崩盘预警整理成一份短讯，直接发到你的收件箱。安静、不刷屏，只在有硬货时出现。
            </p>

            {done ? (
              <div className="mt-6 flex items-center gap-2 rounded-full bg-secondary-500/20 px-5 py-3 text-sm font-semibold text-secondary-100 ring-1 ring-secondary-400/40">
                <i className="ri-checkbox-circle-fill text-lg"></i>
                已登记，有实锤现场我们第一个喊你。
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="mt-6 flex w-full max-w-lg flex-col gap-3 sm:flex-row">
                <label htmlFor="nk-email" className="sr-only">
                  邮箱地址
                </label>
                <input
                  id="nk-email"
                  name="email"
                  type="email"
                  required
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                  placeholder="输入邮箱，订阅实锤快讯"
                  className="min-w-0 flex-1 rounded-full border border-background-50/20 bg-background-50/10 px-5 py-3 text-sm text-background-50 placeholder:text-background-100/50 outline-none transition-colors focus:border-accent-300 focus:ring-2 focus:ring-accent-400/30"
                />
                <button
                  type="submit"
                  className="cursor-pointer whitespace-nowrap rounded-full bg-accent-500 px-6 py-3 text-sm font-bold text-foreground-950 transition-colors hover:bg-accent-400"
                >
                  订阅实锤
                  <i className="ri-mail-send-line ml-1.5"></i>
                </button>
              </form>
            )}

            <p className="mt-3 text-[11px] text-background-100/50">
              仅用于发送实锤现场快讯，绝不外泄，随时可退订。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}